module.exports = __webpack_public_path__ + "277646d9abaed9d7656751b6c6e56d8f.MP3";